module.exports = __webpack_public_path__ + "img/ellington.35923ee.webp";